import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import { Container } from 'components/Container/Container'
import { UserProfileContainer } from '../../features/UserProfile/UserProfileContainer'
import { Menu } from 'components/Menu/Menu'
import useRouter from 'hooks/useRouter'
import { getUser } from 'redux/store/user/getters'
import { safeString } from '../../helper/common'
import { getVendorInfo } from '../../redux/store/vendorInfo/getters'
import { ACTIONS, ability, updateAbility } from 'features/Permission'
import { SETTINGS_TABS } from './constants'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import './styles.scss'
import { NotificationsSetup } from '../../features/NotificationsSetup/NotificationsSetup'

const Settings = () => {
  const [tabs, setTabs] = useState<ItemType[]>([])
  const { tab } = useParams()
  const [activeTab, setActiveTab] = useState(tab || SETTINGS_TABS[0].key)
  const user = useSelector(getUser)
  const { push } = useRouter()
  const vendorInfo = useSelector(getVendorInfo)

  useEffect(() => {
    if (user.uuid) {
      updateAbility(ability, user, vendorInfo)
      const tabs = SETTINGS_TABS.map((i) => ({
        ...i,
        danger: ability.cannot(ACTIONS.VIEW, i.label)
      }))
      setTabs(tabs.filter((tab) => !tab.danger).length > 1 ? tabs : [])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.uuid, ability, vendorInfo])

  useEffect(() => {
    setActiveTab(safeString(tab))
  }, [tab])
  return (
    <Container
      className="settings"
      title={'Settings'}
      menu={
        <Menu
          mode="horizontal"
          onSelect={(e) => {
            setActiveTab(e.key)
            push(e.key)
          }}
          selectedKeys={[activeTab]}
          defaultSelectedKeys={[activeTab]}
          items={tabs}
        />
      }
    >
      <Routes>
        <Route
          path={SETTINGS_TABS[0].key}
          element={<UserProfileContainer setActiveTab={setActiveTab} />}
        >
          <Route
            path={':type'}
            element={<UserProfileContainer setActiveTab={setActiveTab} />}
          />
        </Route>
        <Route path={SETTINGS_TABS[2].key} element={<NotificationsSetup />} />
        <Route index element={<Navigate to={SETTINGS_TABS[0].key} replace />} />
      </Routes>
    </Container>
  )
}

export default Settings
